import React from "react";
import cx from "classnames";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { Play } from "assets/media/svgs";

import * as styles from "./SpotlightItem.module.scss";
import { Spotlight } from "types";

const SpotlightItem: React.FC<Spotlight> = ({
  attributes: { url, description, title, poster },
}) => {
  const image = getImage(poster.data.attributes.localFile);
  return (
    <div className={styles.SpotlightItem}>
      <div className={styles.SpotlightItem_media}>
        <GatsbyImage image={image!} alt={title} objectFit="cover" />
        <a
          href={url}
          target="_blank"
          rel="nofollow noreferrer"
          className={styles.SpotlightItem_action}
        >
          <Play />
        </a>
      </div>
      <div>
        <h3
          className={cx(styles.SpotlightItem_text, styles.SpotlightItem_title)}
        >
          {title}
        </h3>
        <p className={cx(styles.SpotlightItem_text, styles.SpotlightItem_desc)}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default SpotlightItem;
